import { render, staticRenderFns } from "./LeavePageApplicationPendingForm.vue?vue&type=template&id=72961e58&scoped=true&"
import script from "./LeavePageApplicationPendingForm.vue?vue&type=script&lang=js&"
export * from "./LeavePageApplicationPendingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72961e58",
  null
  
)

export default component.exports